import React, { FC, ReactNode } from 'react';
import getClassName from 'src/common/utils/getClassName';

import s from './EventDetailsContent.module.scss';

type EventDetailsContentProps = {
  children: ReactNode;
  classNameModifier?: string;
};

const EventDetailsContent: FC<EventDetailsContentProps> = ({ children, classNameModifier }) => (
  <div className={getClassName(s, 'root', classNameModifier)}>
    <div className={s.content}>
      {children}
    </div>
  </div>
);

export default EventDetailsContent;
